import { useEffect, useState } from "react";

import type { AdminAuditLogItem, AdminListPagination } from "@chaochud/contracts";

import { DataTable, PageHeader } from "@/components/admin-ui";
import { adminOpsClient } from "@/lib/api-clients";

export function AuditLogsPage() {
  const [items, setItems] = useState<AdminAuditLogItem[]>([]);
  const [pagination, setPagination] = useState<AdminListPagination | null>(null);
  const [page, setPage] = useState(1);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void adminOpsClient
      .listAuditLogs(page)
      .then((data) => {
        setItems(data.items);
        setPagination(data.pagination);
      })
      .catch((err) => setError(err instanceof Error ? err.message : "โหลดไม่สำเร็จ"));
  }, [page]);

  return (
    <div className="space-y-6">
      <PageHeader title="Audit Logs" />
      {error ? <p className="text-sm text-error-text">{error}</p> : null}
      <DataTable
        headers={["เมื่อ", "Action", "Resource", "Actor"]}
        rows={items.map((item) => [
          new Date(item.createdAt).toLocaleString("th-TH"),
          item.action,
          `${item.resourceType}:${item.resourceId?.slice(0, 8) ?? "-"}`,
          item.actorUserId?.slice(0, 8) ?? item.actorType,
        ])}
        pagination={pagination ?? undefined}
        onPageChange={setPage}
      />
    </div>
  );
}
